import { render, staticRenderFns } from "./PrivilegeTree.vue?vue&type=template&id=59a3d5e1&scoped=true"
import script from "./PrivilegeTree.vue?vue&type=script&lang=js"
export * from "./PrivilegeTree.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeTree.vue?vue&type=style&index=0&id=59a3d5e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a3d5e1",
  null
  
)

export default component.exports